// extracted by mini-css-extract-plugin
export default {"modal":"KY-z","overlay":"LY-z","outfitSelector":"MY-z","outfitHeading":"NY-z","itemContainer":"OY-z","item":"PY-z","selected":"QY-z"};